import centralAPI from "../CentralAPIHandler/CentralAPIHandler";
import { getParams } from "./getParams";

const params = getParams()?.params;

export const captureMetrics = async ({dealerVinId=null, analyticsData=null, apiCallFlag=null, sessionId=null, timeSpent=0, engagement=null, teamId=null, totalViewDuration=null, activeViewDuration=null, unLoadFlag=false}) => {
    //POST API call to store the metrics

    const payload = {
        mediaId: params?.mediaId,
        skuName: params?.skuName,
        enterpriseId: params?.enterpriseId,
        dealerVinId,
        version: params?.mediaId ? "v2" : null,
        teamId: teamId,
        sessionId: sessionId
    };

    if (totalViewDuration) {
        payload.totalViewDuration = totalViewDuration;
    }

    if (activeViewDuration) {
        payload.activeViewDuration = activeViewDuration;
    }

    if (apiCallFlag){
        payload.actionBy = apiCallFlag;
    }

    if (analyticsData) {
        payload.analytics = analyticsData;
    }

    if (timeSpent) {
        payload.timeSpent = timeSpent;
    }

    if (engagement) {
        payload.engagement = engagement;
    }
    // console.log(payload, "called capture metrics with payloaddd")
    
    // For unload events, use fetch with keepalive
    if (unLoadFlag) {
        fetch(`${process.env.REACT_APP_BASEURL_API_SPYNE}/spin/create-iframe-event`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true
        }).catch(err => {
            console.log(err, "error in capture metrics")
        });
        return;
    }
    
    // Regular API call for non-unload events
    try {
        centralAPI.handlePostRequest(
            `${process.env.REACT_APP_BASEURL_API_SPYNE}/spin/create-iframe-event`,
            payload
        );
    } catch (analyticsError) {
        console.error('Failed to send analytics:', analyticsError);
    }
}